// DHG: arrow buttons now have accessible labels and image alt text
var dhgPrevArrow = "<button type='button' class='slick-prev pull-left' aria-label='Previous'><img src='https://cdn.shopify.com/s/files/1/0886/0155/9357/files/right.png?v=1733393372' alt='Previous' width='18' height='18'></button>";
var dhgNextArrow = "<button type='button' class='slick-next pull-right' aria-label='Next'><img src='https://cdn.shopify.com/s/files/1/0886/0155/9357/files/right.png?v=1733393372' alt='Next' width='18' height='18'></button>";

// Function to initialize Slick slider
function initializeSlick() {
  if (!$('.collection_slider').hasClass('slick-initialized')) {
    $('.collection_slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: dhgPrevArrow,
      nextArrow: dhgNextArrow,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 880,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 680,
          settings: "unslick" // Disable Slick at this breakpoint
        }
      ]
    });
  }
}

// Initialize Slick on page load
initializeSlick();

// Reinitialize Slick on window resize
$(window).on('resize', function() {
  if ($(window).width() > 680) {
    initializeSlick();
  }
});


 $('.reviewss').slick({
  dots: false,
  infinite: true,
   autoplay: true,
  autoplaySpeed: 2000,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: dhgPrevArrow,
  nextArrow: dhgNextArrow,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.custom_blocks_sec .outer_loop_new').slick({
  dots: false,
  infinite: false,
  speed: 300,
  arrows:false,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
